// BackPocket — a loyalty card peeking out of a wallet.
// Cream card (with slim stripe) tilted into a lime wallet with a subtle slot line.
// tone="dark" is default; tone="light" inverts the card fill for canvas surfaces.
export function BrandMark({ size = 32, tone = "dark", accent = "#C8FF4D", tile: tileColor }) {
  const light = tone === "light";
  const tile = tileColor || (light ? "#F4F1E9" : "#0B0D10");
  const cardBg = light ? "#0B0D10" : "#F4F1E9";
  const cardStrip = light ? "#F4F1E9" : "#0B0D10";
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="BackPocket" role="img">
      <rect width="48" height="48" rx="11" fill={tile} />
      {/* Card, tilted, peeking above the wallet */}
      <g transform="rotate(-8 24 17)">
        <rect x="14" y="10" width="20" height="16" rx="2" fill={cardBg} />
        <rect x="15.2" y="12.8" width="17.6" height="1.6" rx="0.2" fill={cardStrip} />
      </g>
      {/* Wallet body */}
      <rect x="9" y="21" width="30" height="18" rx="4.5" fill={accent} />
      {/* Slot line — subtle depth cue */}
      <rect x="12" y="25.4" width="24" height="0.75" rx="0.35" fill="#0B0D10" opacity="0.28" />
    </svg>
  );
}
